class Options {
    _useMonthly = false;
    _mappings = {
        makes: {},
        models: {},
        variants: {}
    };
    _ageData = [];
    _facets = undefined;
    _storeData = [];
    get useMonthly() {
        return this._useMonthly;
    }
    set useMonthly(useMonthly) {
        this._useMonthly = useMonthly;
    }
    get mappings() {
        return this._mappings;
    }
    set mappings(mappings) {
        this._mappings = mappings;
    }
    get ageData() {
        return this._ageData;
    }
    set ageData(ageData) {
        this._ageData = ageData;
    }
    get facets() {
        return this._facets;
    }
    set facets(facets) {
        this._facets = facets;
    }
    get storeData() {
        return this._storeData;
    }
    set storeData(storeData) {
        this._storeData = storeData;
    }
}
export const options = new Options();
